<template>
  <Teleport to="body">
    <div
        class="modal fade"
        :class="{ show: visible, 'd-block': mounted }"
        tabindex="-1"
        role="dialog"
        aria-modal="true"
        @mousedown.self="onBackdropMouseDown"
        @click.self="handleBackdrop"
    >
      <div class="modal-dialog" :class="{'modal-dialog-centered': centered}">
        <div class="modal-content">

          <div class="modal-header">
            <h1 class="modal-title fs-5">
              {{ title }}
            </h1>
            <button
                type="button"
                class="btn-close"
                aria-label="Close"
                @click="close"
            ></button>
          </div>

          <div class="modal-body">
            <slot />
          </div>

          <div class="modal-footer" v-if="$slots.footer">
            <slot name="footer" />
          </div>

        </div>
      </div>
    </div>

    <div
        v-if="mounted"
        class="modal-backdrop fade"
        :class="{ show: visible }"
    ></div>
  </Teleport>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';

const props = defineProps({
  title: { type: String, default: '' },
  centered: { type: Boolean, default: false },
  closeOnBackdrop: { type: Boolean, default: true },
});
const emit = defineEmits(['close']);

const mounted = ref(false);
const visible = ref(false);
const backdropMouseDown = ref(false); // <-- ВАЖНО
let timer = null;

onMounted(async () => {
  mounted.value = true;
  await nextTick();
  requestAnimationFrame(() => {
    visible.value = true;
  });
});

onBeforeUnmount(() => {
  if (timer) clearTimeout(timer);
});

function close() {
  visible.value = false;
  timer = setTimeout(() => {
    emit('close');
  }, 150);
}

function onBackdropMouseDown(e) {
  backdropMouseDown.value = e.target === e.currentTarget;
}

function handleBackdrop(e) {
  if (!props.closeOnBackdrop) return;
  if (e.target !== e.currentTarget) return;
  if (!backdropMouseDown.value) return;
  close();
}

</script>

<style scoped>
.modal.fade {
  transition: opacity .15s linear;
}
.modal.fade .modal-dialog {
  transition: transform .3s ease-out;
  transform: translate(0, -10px);
}
.modal.show .modal-dialog {
  transform: translate(0, 0);
}
</style>
